import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { OcpApplianceRegistrationApiRef } from './api/OcpApplianceRegistrationApi';
import { OcpApplianceRegistrationClient } from './api/OcpApplianceRegistrationClient';

export const ocpApplianceRegistrationPlugin = createPlugin({
  id: 'ocp-appliance-registration',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: OcpApplianceRegistrationApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) =>
        new OcpApplianceRegistrationClient({ discoveryApi, identityApi }),
    }),
  ],
});

export const OcpApplianceRegistrationPage =
  ocpApplianceRegistrationPlugin.provide(
    createRoutableExtension({
      name: 'OcpApplianceRegistrationPage',
      component: () => import('./components/MainPage').then(m => m.MainPage),
      mountPoint: rootRouteRef,
    }),
  );
